import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import { serverInfo } from "../../../App";
import "../../../assets/CSS/PendingPromoVideo.css";
import clock from "../../../assets/Icon/clockevent.png";

const PostDetails = (props) => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [event, setEvent] = useState("");

  useEffect(() => {
    let isMounted = true;

    const event_id = props.match.params.id;

    axios.get(`/api/admin/simple_post/pending/${event_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setEvent(res.data.post);
        }
      }
    });
  }, [props.match.params.id, history]);

  const videoPreview = (data) => {
    if(data.thumbnail){
      return (<img
        src={
          imageCdnUrl + data.thumbnail
            ? imageCdnUrl + data.thumbnail
            : 'noImage'
        }
        className="img-fluid image-hover-link"
        alt=""
        style={{ height: "200px", width: "100%" }}
      />)

    }else {

      return (<ReactPlayer
        url={videoCdnUrl + data.video}
        controls={true}
        volume={1}
        width="100%"
        height="200px"
        style={{ margin: "0 auto" }}
      />)
    }
  }

  return (
    <div className="">
      <div className="row">
        <div className="col-md-6">
          <div className="card card-bg p-3 mb-3">
            {event?.image !== null || event?.video !== null ? (
              <>
                {event.post_type == 'video' ? videoPreview(event) : (

                  <img
                    src={imageCdnUrl + event.image}
                    alt=""
                    className="img-fluid Banner-SME-b"
                  />
                 
                )}
              </>
            ) : (
              <>
              </>
            )}
          </div>
        </div>

        <div className="col-md-6 mb-3">
          <div className="card card-bg">
            <div className="row">
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <img src={clock} className="img-fluid p-3" alt="" />
              </div>
              <div className="col-md-4 d-flex align-items-center">
                <div>
                  <h5 className="text-warning">Post Details submitted</h5>
                  <p className="text-light">
                    {Number(event.status) === 1 ? (
                      <>Already Published</>
                    ) : event.star_approval === 1 ? (
                      <>Waiting for &nbsp; Manager Admin Approval</>
                    ) : (
                      <>Waiting for &nbsp; Star & Manager Admin Approval</>
                    )}
                    &nbsp;
                  </p>
                  {event.star_approval < 1 ? (
                    <Link to={`/superstar-admin/post/edit/${event.id}`}>
                      <button className="btn btnEditTest fw-bold">
                        Edit Post
                      </button>
                    </Link>
                  ) : null}
                </div>
              </div>

              <div
                className="col-md-4"
                style={{ borderLeft: "1px dashed yellow" }}
              >
                <h5 className="text-light text-center my-3">Status</h5>
                <div className="d-flex justify-content-center align-items-center p-2 ">
                  <div style={{ width: 150, height: 150 }}>
                    {Number(event.status) === 1 ? (
                      <CircularProgressbarWithChildren
                        value={100}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">100% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : event.star_approval === 1 ? (
                      <CircularProgressbarWithChildren
                        value={50}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">50% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : (
                      <CircularProgressbarWithChildren
                        value={0}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">0% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12 mb-3">
        <div className="card card-bg shadow">
          <div className="card-body">
            <h5 className="text-light ">{event.title}</h5>

            <p className="text-light ">
              <Markup content={event.instruction} />
            </p>

            <h5 className="text-warning">Description</h5>
            <div className="under-line"></div>
            <p className="text-light mt-2">
              <Markup content={event.description} />
            </p>

            <div className="col-md-3 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
              <h5 className="text-warning pt-2 ">Fees : ${event.fee}</h5>
              <p className="text-light fw-bold pt-2">
                {moment(event.created_at).format("LL")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostDetails;
